module.exports = "<h2>Page Not Found !</h2>\n<a [routerLink]=\"['/home']\">Go Back to Home Page</a>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = ./src/app/not-found/not-found.component.html
// module chunks = main